/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../theme/theme"
import { css } from "@mui/material"

interface PageIndicatorProps {
    totalPages: number
    currentPage: number
    onPageClick: (index: number) => void
}

const DotIndicatorContainerStyle = withMyTheme((theme) => css`
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 2rem;
`)

const DotStyle = withMyTheme((theme, active) => css`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${active ? theme.palette.primary.main : theme.palette.grey[300]};
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
        background-color: ${active ? theme.palette.primary.dark : theme.palette.grey[400]};
        transform: scale(1.1);
    }
`)

export const PageIndicator = ({ totalPages, currentPage, onPageClick }: PageIndicatorProps) => {
    return (
        <div css={DotIndicatorContainerStyle}>
            {Array.from({ length: totalPages }, (_, index) => (
                <div
                    key={index}
                    css={theme => DotStyle(theme, index === currentPage)}
                    onClick={() => onPageClick(index)}
                />
            ))}
        </div>
    )
}